const API_URL = `${process.env.REACT_APP_URL_API}${process.env.REACT_APP_PATH_COMENTARIO}`;

//crear un comentario
export const createComentario = async ({ token, formData }) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Error al crear el comentario');
        }

        return await response.json();
    }catch (error) {
        throw error;
    }
};

//obtener un comentario by IDDenuncia
export const getComentarioByDenunciaID = async ({ token, denunciaID }) => {
    try {
        const response = await fetch(`${API_URL}/denuncia/${denunciaID}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            throw new Error('Error al obtener los comentarios');
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        throw error;
    }
};

//actualizar el comentario by ID
export const updateComentario = async ({ token, comentarioID, formData }) => {
    try {
        const response = await fetch(`${API_URL}/${comentarioID}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: formData,
        });
        if (!response.ok) {
            throw new Error('Error al actualizar el comentario');
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};